module.exports = __webpack_public_path__ + "img/churchco.0e215d6e.png";